export const runAfterNextPaint = (callback: () => void): void => {
  requestAnimationFrame(() => {
    setTimeout(callback);
  });
};
